module.exports = __webpack_public_path__ + "img/01-medal-gold.0d80b681.svg";